import Vue from 'vue'
import Router from 'vue-router'
import Notfound from '../components/404.vue'
import home from '../components/home'
import cobranding from "../components/cobranding.vue" // 品牌合作
import contactUs from "../components/contactUs.vue" // 联系我们
// EDG动态
import journalism from "../components/journalism.vue" // 新闻
import newsDetail from "../components/newsDetail.vue" // 新闻详情
import videolist from "../components/videolist.vue" // 视频
import wallpaper from "../components/wallpaper.vue" // 壁纸

// 关于EDG
import weAreEDG from "../components/weAreEDG.vue" // we are EDG
import briefIntroduction from "../components/briefIntroduction.vue" // EDG简介
import warTeam from "../components/warTeam.vue" // 战队简介
import honor from "../components/honor.vue" // 战队简介
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    //品牌合作
    {
      path: '/home/cobranding',
      name: "cobranding",
      component: cobranding
    },
    //联系我们
    {
      path: '/home/contactUs',
      name: "contactUs",
      component: contactUs
    },
    //EDG动态 -> 新闻
    {
      path: '/home/journalism',
      name: "journalism",
      component: journalism
    },
    //EDG动态 -> 新闻详情
    {
      path: '/home/newsDetail',
      name: "newsDetail",
      component: newsDetail
    },
    //EDG动态 -> 视频
    {
      path: '/home/videolist',
      name: "videolist",
      component: videolist
    },
    //EDG动态 -> 壁纸
    {
      path: '/home/wallpaper',
      name: "wallpaper",
      component: wallpaper
    },
    //关于EDG -> we are EDG
    {
      path: '/home/weAreEDG',
      name: "weAreEDG",
      component: weAreEDG
    },
    //关于EDG -> EDG简介
    {
      path: '/home/briefIntroduction',
      name: "briefIntroduction",
      component: briefIntroduction
    },
    // //关于EDG -> 战队简介
    {
      path: '/home/warTeam',
      name: "warTeam",
      component: warTeam
    },
    // //关于EDG -> we are EDG
    {
      path: '/home/honor',
      name: "honor",
      component: honor
    },
    { //注意，这个路由必须放在最后，添加路由都在它之上添加
      path: '*',
      name: "Notfound",
      components: {
        other: Notfound
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js